exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel {\n  font-weight: 600;\n}\ndiv.el-textarea>textarea {\n  line-height: 40px;\n}\nspan.bntext {\n  cursor: pointer;\n  display: block;\n  height: 280px;\n  width: 100%;\n  padding: 0 5px;\n  word-break: break-all;\n  overflow-y: scroll;\n  border: 1px solid #eee;\n}\nspan.frm-tips {\n  color: #f00;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0f4f4a65","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/setting/itemsflag/index.vue
// module id = 1217
// module chunks = 0